import initialStore from "../initialStore";

export default function oddReducer(state= initialStore.odd) {
    return state
}